
/** --------------------------------------------------------------------------------------------------
 * 開啟'儲存中'視窗
 * -------------------------------------------------------------------------------------------------- */

window.showLoadingDialog = function() {

    // ------------------------ 儲存中視窗 -------------------
    if ($('#loading-wrapper').length == 0) {
        $('body').append('<div id="loading-wrapper" style="position:fixed;width:100%;height:100%;left:0;top:0;z-index:999">' +
            '<i class="fa fa-spinner fa-pulse fa-5x fa-fw margin-bottom" style="position:fixed;left:50%;top:50%"></i>' +
            '</div>');
    }

    $("#loading-wrapper").addClass('show').show();

} // end of method

window.hideLoadingDialog = function() {

    $("#loading-wrapper").removeClass('show').hide();

} // end of method
